import React from "react";
import { Modal } from "../../../../../../shared/Modal/Modal.js";
import { Button } from "../../../../../../shared/Button/Button.js";
import { InfoIcon } from "../../../../../../assets/Icons/InfoIcon.js";
import styles from "./scss/ClearentSurchargeEnrollmentModal.module.scss";

const ClearentSurchargeEnrollmentModal = ({ onContinue, onBack }) => {
  return (
    <Modal
      isOpen
      onClose={onBack}
      header={
        <Modal.Title>
          <span className={styles.titleWithIcon}>
            <InfoIcon width="22px" />
            Surcharge Enrollment Required
          </span>
        </Modal.Title>
      }
      footer={
        <div className={styles.footerContainer}>
          {onContinue ? (
            <>
              <Button variant="outlined" onClick={onBack}>
                Back
              </Button>
              <Button onClick={onContinue}>Continue</Button>
            </>
          ) : (
            <Button onClick={onBack}>Close</Button>
          )}
        </div>
      }
      footerNoBorder
    >
      <div className={styles.content}>
        <p>
          To use surcharging through Clearent&apos;s payment processing system,
          enrollment in the Clearent Empower Program is required.
        </p>
        <p>
          As part of the enrollment process, Clearent will provide a card brand
          compliance document outlining all applicable rules and requirements.
          This document must be reviewed and signed before surcharging can be
          activated. Once Clearent receives the signed document, they will
          update your account settings to enable the surcharge feature.
        </p>
        <p>
          Please note that your payment processing rates may be adjusted as part
          of the surcharge enrollment process.
        </p>
        <p>
          Participation in the Empower Program also requires you to review and
          acknowledge the card brand compliance document every six months.
          Failure to complete the required re-attestation within the designated
          timeframe may result in a $49.95 monthly fee per Merchant ID for each
          month the attestation remains incomplete. All attestations must be
          completed through the Merchant Portal.
        </p>
        <p>
          If you would like to enable surcharging for your account, please
          contact us at{" "}
          <a href="mailto:processing@aestheticrecord.com">
            processing@aestheticrecord.com
          </a>{" "}
          to begin the enrollment process.
        </p>
      </div>
    </Modal>
  );
};

export default ClearentSurchargeEnrollmentModal;
